import React from 'react';

const DeviceDetectionContext = React.createContext();

export function DeviceDetectionProvider({ children }) {
	const [isMobile, setMobile] = React.useState(false);
	const [windowWidth, setWindowWidth] = React.useState(window.outerWidth);

	React.useEffect(() => {
		const mobile = windowWidth <= 992;
		setMobile(mobile);
	}, [windowWidth]);

	const handleWindowResize = () => {
		setWindowWidth(window.outerWidth);
	};

	window.addEventListener('resize', handleWindowResize);

	return (
		<DeviceDetectionContext.Provider children={children} value={isMobile} />
	);
}

export function useDeviceDetection() {
	return React.useContext(DeviceDetectionContext);
}
